import React, { useContext, useEffect, useState } from 'react'
import styles from './ManageEachStaffProfile.module.css'
import { BsImage } from "react-icons/bs"
import { useParams } from 'react-router'
import { BASE_URL_API } from '../../References/URLs'
import AuthContext from '../../store/auth-context'
import ActiveStoreContext from '../../store/ActiveStoreContext'
import { toast } from 'react-toastify'
import { indianBankNameList } from '../../Helper/indianBankNameList'
import { motion } from 'framer-motion'
import { AiOutlineLoading3Quarters } from 'react-icons/ai'
import { User, Phone, Mail, MapPin, Briefcase, Landmark, CircleHelp, IndianRupee } from 'lucide-react'
import Select from 'react-select'

const jobProfiles = [
    {
        "categoryId": "1",
        "label": "Beautician"
    },
    {
        "categoryId": "15",
        "label": "Beauty Advisor / Consultant"
    },
    {
        "categoryId": "13",
        "label": "Beauty Trainer"
    },
    {
        "categoryId": "22",
        "label": "Eye-lash Extension Expert"
    },
    {
        "categoryId": "19",
        "label": "Eyelash Trainer"
    },
    {
        "categoryId": "20",
        "label": "Female Hairdresser / Hairstylist"
    },
    {
        "categoryId": "17",
        "label": "Gents Hairdresser / Hairstylist"
    },
    {
        "categoryId": "14",
        "label": "Hair Trainer"
    },
    {
        "categoryId": "9",
        "label": "Helper"
    },
    {
        "categoryId": "12",
        "label": "Make-up Trainer"
    },
    {
        "categoryId": "2",
        "label": "Makeup Artist"
    },
    {
        "categoryId": "11",
        "label": "Manager"
    },
    {
        "categoryId": "4",
        "label": "Manicurist"
    },
    {
        "categoryId": "16",
        "label": "Massage Therapist"
    },
    {
        "categoryId": "21",
        "label": "Mehandi Artist"
    },
    {
        "categoryId": "6",
        "label": "Nail Art / Technician"
    },
    {
        "categoryId": "18",
        "label": "Nail Art Trainer"
    },
    {
        "categoryId": "5",
        "label": "Pedicurist"
    },
    {
        "categoryId": "10",
        "label": "Receptionist"
    },
    {
        "categoryId": "3",
        "label": "Unisex Hairdresser / Hairstylist"
    }
]

const ManageEachStaffProfile = () => {
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext);
    const activeStore = (() => { try { return asCtx?.activeStore && asCtx.activeStore.trim() !== "" ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();
    const [isUpdating, setIsUpdating] = useState(false)

    const { staffIdentifier } = useParams()
    const [profileDetails, setProfileDetails] = useState(null)

    const getStaffProfileDetails = async () => {
        const getStaffProfileDetailsResponse = await fetch(BASE_URL_API + "getStaffProfileDetails",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    storeIdentifier: activeStore.storeIdentifier,
                    staffIdentifier: staffIdentifier
                })
            });

        if (!getStaffProfileDetailsResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const getStaffProfileDetailsRespo = await getStaffProfileDetailsResponse.json()
            if (getStaffProfileDetailsRespo.status === 'success') {
                setProfileDetails(getStaffProfileDetailsRespo?.response)
            } else {
                if (getStaffProfileDetailsRespo.message === "tokenExpired") {
                    authCtx.logout()
                } else {

                }
            }
            console.log(getStaffProfileDetailsRespo)
        }
    }

    useEffect(() => {
        getStaffProfileDetails()
    }, [staffIdentifier])

    const updateStaffProfileDetails = async () => {
        setIsUpdating(true)
        const updateStaffProfileDetailsResponse = await fetch(BASE_URL_API + "updateStaffProfileDetails",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    storeIdentifier: activeStore.storeIdentifier,
                    staffIdentifier: staffIdentifier,
                    profileDetails: profileDetails
                })
            });

        if (!updateStaffProfileDetailsResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const updateStaffProfileDetailsRespo = await updateStaffProfileDetailsResponse.json()
            if (updateStaffProfileDetailsRespo.status === 'success') {
                toast(`Profile details successfully udpated!`)
            } else {
                if (updateStaffProfileDetailsRespo.message === "tokenExpired") {
                    authCtx.logout()
                } else {

                }
            }
            console.log(updateStaffProfileDetailsRespo)
        }
        setIsUpdating(false)
    }

    const updateDetailsHandler = (f, v) => {
        setProfileDetails(prevState => ({
            ...prevState,
            [f]: v
        }));
    };

    const bankOptions = indianBankNameList.map(bank => ({
        value: bank.bankName,
        label: bank.bankName
    }));

    const bankSelectStyles = {
        control: (base, state) => ({
            ...base,
            padding: '0.05rem 0.1rem',
            borderRadius: '8px',
            border: state.isFocused ? '1px solid #6d28d9' : '1px solid #dfe7f4',
            boxShadow: state.isFocused ? '0 0 0 3px rgba(111, 76, 255, 0.1)' : 'none',
            fontSize: '0.85rem',
            fontFamily: 'inherit',
            color: '#0f172a',
            background: '#fff',
            cursor: 'pointer',
            transition: 'all 0.18s ease',
            '&:hover': { borderColor: '#6d28d9' },
        }),
        menu: (base) => ({
            ...base,
            borderRadius: '8px',
            border: '1px solid #dfe7f4',
            boxShadow: '0 8px 20px rgba(12, 26, 75, 0.12)',
            overflow: 'hidden',
            zIndex: 1000,
        }),
        menuList: (base) => ({
            ...base,
            padding: '4px 0',
            maxHeight: '220px',
        }),
        option: (base, state) => ({
            ...base,
            fontSize: '0.8rem',
            fontWeight: state.isSelected ? 600 : 500,
            color: state.isSelected || state.isFocused ? '#6d28d9' : '#334155',
            background: state.isSelected ? '#ede9fe' : state.isFocused ? '#f5f3ff' : '#fff',
            padding: '0.5rem 0.75rem',
            cursor: 'pointer',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#0f172a',
            fontSize: '0.85rem',
        }),
        placeholder: (base) => ({
            ...base,
            color: '#94a3b8',
            fontSize: '0.85rem',
        }),
        indicatorSeparator: () => ({ display: 'none' }),
        dropdownIndicator: (base, state) => ({
            ...base,
            color: state.isFocused ? '#6d28d9' : '#94a3b8',
            transition: 'color 0.18s ease',
            padding: '0 6px',
        }),
        clearIndicator: (base) => ({
            ...base,
            color: '#94a3b8',
            '&:hover': { color: '#6d28d9' },
            padding: '0 4px',
        }),
    };

    const pageMotion = {
        hidden: { opacity: 0 },
        show: {
            opacity: 1,
            transition: { duration: 0.32, ease: 'easeOut', staggerChildren: 0.08 }
        }
    }

    const sectionMotion = {
        hidden: { opacity: 0, y: 12 },
        show: { opacity: 1, y: 0, transition: { duration: 0.32, ease: 'easeOut' } }
    }

    return (
        <motion.div className={styles.mainWrapper} variants={pageMotion} initial="hidden" animate="show">
            {/* Page Header */}
            <div className={styles.pageHeader}>
                <div className={styles.pageHeaderLeft}>
                    <h1 className={styles.pageTitle}>{profileDetails?.name || 'Staff Profile'}</h1>
                    <p className={styles.pageSubtitle}>Edit and manage staff details, contact, and payment information.</p>
                </div>
                <button
                    onClick={() => updateStaffProfileDetails()}
                    disabled={isUpdating}
                    className={styles.saveBtnHeader}
                >
                    {isUpdating ? (
                        <>
                            <AiOutlineLoading3Quarters className={styles.spinnerIcon} />
                            Saving...
                        </>
                    ) : (
                        'Save Changes'
                    )}
                </button>
            </div>

            {/* Content Grid */}
            <motion.div className={styles.contentGrid} variants={pageMotion} initial="hidden" animate="show">
                {/* Left Column: Personal Information */}
                <motion.div className={styles.cardSection} variants={sectionMotion}>
                    <motion.div className={styles.profileCard} variants={sectionMotion}>
                        <div className={styles.cardTitle}>
                            <User size={18} /> Personal Information
                        </div>
                        <div className={styles.profileImageWrapper}>
                            <img src="https://thesalonbusiness.com/wp-content/uploads/2020/03/hairdresser-profile-picture.png" alt="Profile" className={styles.profileImage} />
                            <button className={styles.updatePhotoBtn}>
                                <BsImage size={14} /> Update Photo
                            </button>
                        </div>
                        <div className={styles.fieldRow}>
                            <label>Full Name</label>
                            <input type="text" value={profileDetails?.name || ''} onChange={(e) => updateDetailsHandler('name', e.target.value)} placeholder="Enter full name" />
                        </div>
                        <div className={styles.fieldRow}>
                            <label><Phone size={14} /> Phone</label>
                            <input type="tel" value={profileDetails?.mobile || ''} onChange={(e) => updateDetailsHandler('mobile', e.target.value)} placeholder="Enter phone number" />
                        </div>
                        <div className={styles.fieldRow}>
                            <label><Mail size={14} /> Email</label>
                            <input type="email" value={profileDetails?.email || ''} onChange={(e) => updateDetailsHandler('email', e.target.value)} placeholder="Enter email address" />
                        </div>
                        <div className={styles.fieldRow}>
                            <label>Gender</label>
                            <select onChange={(e) => updateDetailsHandler('gender', e.target.value)} value={profileDetails?.gender ? String(profileDetails.gender) : '0'}>
                                <option value="0">Select Gender</option>
                                <option value="2">Female</option>
                                <option value="1">Male</option>
                                <option value="3">Others</option>
                            </select>
                        </div>
                    </motion.div>
                </motion.div>

                {/* Center Column: Description & Address */}
                <motion.div className={styles.cardSection} variants={sectionMotion}>
                    <motion.div className={styles.largeCard} variants={sectionMotion}>
                        <div className={styles.cardTitle}>Profile Description</div>
                        <textarea 
                            placeholder="Add staff description, specialties, achievements..." 
                            value={profileDetails?.description || ''} 
                            onChange={(e) => updateDetailsHandler('description', e.target.value)}
                            className={styles.descriptionInput}
                        />
                    </motion.div>
                    <motion.div className={styles.largeCard} variants={sectionMotion}>
                        <div className={styles.cardTitle}>
                            <MapPin size={18} /> Address Information
                        </div>
                        <div className={styles.fieldRow}>
                            <label>Current Address</label>
                            <textarea 
                                placeholder="Enter current residential address" 
                                value={profileDetails?.currentAddress || ''} 
                                onChange={(e) => updateDetailsHandler('currentAddress', e.target.value)}
                                className={styles.addressInput}
                            />
                        </div>
                        <div className={styles.fieldRow}>
                            <label>Permanent Address</label>
                            <textarea 
                                placeholder="Enter permanent residential address" 
                                value={profileDetails?.permanentAddress || ''} 
                                onChange={(e) => updateDetailsHandler('permanentAddress', e.target.value)}
                                className={styles.addressInput}
                            />
                        </div>
                    </motion.div>
                </motion.div>

                {/* Right Column: Job, Salary, Payment, Bank */}
                <motion.div className={styles.cardSection} variants={sectionMotion}>
                    <motion.div className={styles.card} variants={sectionMotion}>
                        <div className={styles.cardTitle}>
                            <Briefcase size={18} /> Job Information
                        </div>
                        <div className={styles.fieldRow}>
                            <label>Designation</label>
                            <select onChange={(e) => { const selectedCategoryId = e.target.value; const selectedItem = jobProfiles?.find(item => item.categoryId === selectedCategoryId); setProfileDetails(prevState => ({ ...prevState, designationIdentifier: selectedItem?.categoryId || '', designationLabel: selectedItem?.label || '' })); }} value={profileDetails?.designationIdentifier || ''}>
                                <option value="">Select Designation</option>
                                {jobProfiles?.map((item, index) => (<option key={item?.categoryId || index} value={item.categoryId}>{item?.label}</option>))}
                            </select>
                        </div>
                        <div className={styles.fieldRow}>
                            <label>Joined On</label>
                            <input type="date" value={profileDetails?.joiningDate?.split(' ')[0] || ''} onChange={(e) => { const newDate = e.target.value + ' 10:00:01'; updateDetailsHandler('joiningDate', newDate); }} />
                        </div>
                    </motion.div>

                    <motion.div className={styles.card} variants={sectionMotion}>
                        <div className={styles.cardTitle}>
                            <IndianRupee size={18} /> Salary Information
                        </div>
                        <div className={styles.fieldRow}>
                            <label>Monthly Salary</label>
                            <input type="number" value={profileDetails?.currentMonthlySalary || ''} onChange={(e) => updateDetailsHandler('currentMonthlySalary', e.target.value)} placeholder="0" />
                        </div>
                    </motion.div>

                    <motion.div className={styles.card} variants={sectionMotion}>
                        <div className={styles.cardTitle}>Payment Methods</div>
                        <div className={styles.fieldRow}>
                            <label>UPI ID</label>
                            <input type="text" value={profileDetails?.upiId || ''} onChange={(e) => updateDetailsHandler('upiId', e.target.value)} placeholder="username@upi" />
                        </div>
                    </motion.div>

                    <motion.div className={styles.card} variants={sectionMotion}>
                        <div className={styles.cardTitle}>
                            <Landmark size={18} /> Bank Details
                        </div>
                        <div className={styles.fieldRow}>
                            <label>Bank Name</label>
                            <Select
                                options={bankOptions}
                                value={profileDetails?.bankName ? { value: profileDetails.bankName, label: profileDetails.bankName } : null}
                                onChange={(selected) => updateDetailsHandler('bankName', selected ? selected.value : '')}
                                placeholder="Search and select a bank..."
                                isClearable
                                isSearchable
                                menuPlacement="top"
                                styles={bankSelectStyles}
                            />
                        </div>
                        <div className={styles.fieldRow}>
                            <label>Account Number</label>
                            <input type="text" value={profileDetails?.bankAccountNumber || ''} onChange={(e) => updateDetailsHandler('bankAccountNumber', e.target.value)} placeholder="0000 0000 0000" />
                        </div>
                        <div className={styles.fieldRow}>
                            <label>IFSC Code</label>
                            <input type="text" value={profileDetails?.ifsc || ''} onChange={(e) => updateDetailsHandler('ifsc', e.target.value)} placeholder="IFSC0001234" />
                        </div>
                    </motion.div>
                </motion.div>
            </motion.div>
        </motion.div>
    )
}

export default ManageEachStaffProfile